export default {"id":"0a1dfca9","attrs":{"viewBox":"0 0 22 22","width":"22","height":"22"}}